import {createContext} from 'react';
import {
    AuthUser,
    JWT
} from 'aws-amplify/auth';
import type {AuthStatus} from '@flexinet/auth-components';


type AuthContextType = {
    loading: boolean,
    user: AuthUser | undefined,
    // FNP-1733: whether the session has been RESOLVED. `user` is undefined both
    // while getCurrentUser() is pending and after it answers "nobody", so it
    // cannot tell the two apart. Read this, not `user`, to decide.
    status: AuthStatus,
    idToken?: JWT | undefined,
    accessToken?: JWT | undefined,
    cognitoGroups?: string[] | undefined,
    role?: string | undefined,
    accountId?: string | undefined
}


export const AuthContext = createContext<AuthContextType>({
                                                              loading: true,
                                                              user: {} as AuthUser,
                                                              // 'resolving', never 'anonymous': outside the
                                                              // provider nobody has checked the session yet.
                                                              status: 'resolving',
                                                              idToken: {} as JWT,
                                                              accessToken: {} as JWT,
                                                              cognitoGroups: [] as string[],
                                                              role: undefined,
                                                              accountId: undefined
                                                          });

